/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// Append Fertigvorhang size (HxW) to product titles in search results.
// Uses MutationObserver to catch every render/re-render by Boost SD.
(function () {
  var cache = {}; // handle → size string ("260x140") | null | "pending"

  function applySize(titleEl, handle, baseTitle) {
    var size = cache[handle];
    if (!size || size === 'pending') return;
    if (titleEl.dataset.sizeSet === handle) return; // already set on this node
    titleEl.textContent = baseTitle + ' ' + size;
    titleEl.dataset.sizeSet = handle;
  }

  function processCard(card) {
    var titleEl = card.querySelector('.boost-sd__product-title');
    if (!titleEl) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var match = link.href.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];
    var baseTitle = titleEl.textContent.trim();

    if (cache[handle] !== undefined) {
      applySize(titleEl, handle, baseTitle);
      return;
    }

    cache[handle] = 'pending';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var hTag = (d.tags || []).find(function (t) { return t.indexOf('height:') === 0; });
        var wTag = (d.tags || []).find(function (t) { return t.indexOf('width:') === 0; });
        if (hTag && wTag) {
          cache[handle] = hTag.replace('height:', '') + 'x' + wTag.replace('width:', '');
        } else {
          cache[handle] = null;
        }
        // Update every card with this handle currently in DOM
        document.querySelectorAll('.boost-sd__product-item').forEach(function (c) {
          var a = c.querySelector('a[href*="/products/' + handle + '"]');
          if (!a) return;
          var t = c.querySelector('.boost-sd__product-title');
          if (t) applySize(t, handle, d.title);
        });
      })
      .catch(function () { cache[handle] = null; });
  }

  function processAll() {
    document.querySelectorAll('.boost-sd__product-item').forEach(processCard);
  }

  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (
          (n.matches && n.matches('.boost-sd__product-item')) ||
          (n.querySelector && n.querySelector('.boost-sd__product-item'))
        );
      });
    });
    if (hasNewCards) processAll();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  processAll();
})();
